var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCurveBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 166,
    viewBox: "0 0 361 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3772_48423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 48,
    width: 343,
    height: 87
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.967 125.964C89.6321 119.95 50.4655 112.634 9.16501 112.429L9.18305 56.6554C9.18448 52.2434 12.7594 48.6697 17.1729 48.6683L342.486 48.5641C346.911 48.5627 350.501 52.1512 350.499 56.5743L350.488 90.8816C340.794 101.305 326.904 109.813 311.233 116.405C300.374 120.917 289.024 124.538 277.371 127.208C268.634 129.243 259.769 130.794 250.842 131.85C209.284 136.747 168.303 131.978 128.967 125.964Z",
    fill: "#C4C4C4",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3772_48423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.271,
    y: 48.4998,
    width: 341,
    height: 87,
    rx: 7.5,
    fill: "#039BE5",
    stroke: "#039BE5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCurveBg);
export default __webpack_public_path__ + "static/media/blue-curve-bg.62d45fae.svg";
export { ForwardRef as ReactComponent };